/**
 * Padding for certain types of widgets. Each of the four sides can have a
 * different value for padding.
 *
 * @category Theme
 */
export interface Padding {
    /** Left padding length, in pixels. */
    left: number,
    /** Right padding length, in pixels. */
    right: number,
    /** Top padding length, in pixels. */
    top: number,
    /** Bottom padding length, in pixels. */
    bottom: number,
}
